import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandAws({
    height = 28,
    width = 44,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-aws-brand-logo'
                    : 'provider-aws-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandAws"
            width={width}
        />
    );
}

export default AppLogoBrandAws;
